import React, { useMemo } from 'react';
import { Flex, Card, Box } from '@opendoor/bricks/core';
import { Illustration } from '@opendoor/cinderblocks/platform/Illustration';
import { MOBILE_PROPERTY_CARD_WIDTH } from 'buying/components/propertyCards/PropertyCard';
import { PropertyCardImageContainer } from 'buying/components/propertyCards/PropertyCardImageContainer';
import { useDevice } from '@opendoor/bricks/hooks/useMedia';

interface PropertyPlaceholderCardProps {
  index?: number; // arbitrary number which will be used to rotate which illustrations are shown
}

/** Placeholder card for when we don't have enough PropertyCards to fill a PropertyCardRow */
export const PropertyPlaceholderCard: React.FC<PropertyPlaceholderCardProps> = ({ index = 0 }) => {
  const { isMobile } = useDevice();
  const illustrationName = useMemo(() => {
    switch (index % 4) {
      case 0:
        return 'Home 1';
      case 1:
        return 'Home 2';
      case 2:
        return 'Home 3';
      default:
        return 'Home 4';
    }
  }, [index]);

  return (
    <Card
      width={isMobile ? MOBILE_PROPERTY_CARD_WIDTH : '100%'}
      height="100%"
      variant="tertiary"
      padding={0}
      backgroundColor="neutrals10"
      data-testid="property-card-placeholder"
    >
      <Flex flexDirection="column">
        <PropertyCardImageContainer>
          <Illustration
            type="emptyState"
            illustrationName={illustrationName}
            data-testid={`illustration-${illustrationName}`}
          />
        </PropertyCardImageContainer>
        <Box padding={5}>
          <Box width={132} height={15} mt={1} mb={4} backgroundColor="neutrals30" />
          <Box width={90} height={15} mb={4} backgroundColor="neutrals30" />
          <Box width={132} height={15} backgroundColor="neutrals30" />
        </Box>
      </Flex>
    </Card>
  );
};
